import {Injectable} from '@angular/core';
import {config} from '../../../../config';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {Setting} from './setting.model';

@Injectable()
export class SettingService {
  private endpoint = `${config.apiLocation}/v1/admin`;

  constructor(private http: HttpClient) {
  }

  all(): Observable<Setting[]> {
    return this.http
      .get<Setting[]>(`${this.endpoint}/all-settings`)
      .map(res => res);
  }

  update(key: string, value: string): Observable<Setting> {
    return this.http.post(`${this.endpoint}/update-setting`, {key, value}) as Observable<Setting>;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/settings/setting.service.ts